import * as React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { cn } from '@/lib/utils';

// `@radix-ui/react-popover` is pinned to an exact version in package.json on
// purpose. 1.1.15 depends on the same dismissable-layer / focus-scope /
// popper / portal releases the Dialog, Dropdown and Tooltip wrappers already
// resolve to. A newer popover pulls a SECOND copy of each, and every copy of
// dismissable-layer keeps its own layer stack — so Escape and outside-click
// stop coordinating between a popover and a dialog opened over it. Bump this
// together with the other Radix packages, then check the lockfile still has
// one version of each of those four.

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverAnchor = PopoverPrimitive.Anchor;

export const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, sideOffset = 4, collisionPadding = 8, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      collisionPadding={collisionPadding}
      // Same surface as DropdownMenuContent so swapping a menu for a popover
      // doesn't change how the panel looks.
      className={cn(
        'z-50 overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md outline-none',
        className,
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;
